module.exports = __webpack_public_path__ + "img/braille.027da18b.svg";